<template>
  <sui-page>
    <sui-page-header title="Button UI"></sui-page-header>
    <sui-page-contents>
      <a href="#" class="btn_float"></a>
      <div class="comm_title_wrap">
        <h4>텍스트 버튼</h4>
      </div>
      <div class="btn_wrap">
        <sui-button type="button" class="btn_txt_BK">텍스트버튼타입1</sui-button>
        <sui-button type="button" class="btn_txt_BK" disabled="true">텍스트버튼타입1-disable</sui-button>
        <div class="mrB10"></div>
        <sui-button type="button" class="btn_txt_BL">텍스트버튼타입2-블루</sui-button>
        <sui-button type="button" class="btn_txt_BL" disabled="true">텍스트버튼타입2-disable</sui-button>
        <div class="mrB10"></div>
        <sui-button type="button" class="btn_txt_BL_line">텍스트버튼타입3-블루라인</sui-button>
        <sui-button type="button" class="btn_txt_BL_line" disabled="true">텍스트버튼타입3-disable</sui-button>
        <div class="mrB10"></div>
        <sui-button type="button" class="btn_txt_BL_arrow">텍스트버튼타입4-블루화살표</sui-button>
        <sui-button type="button" class="btn_txt_BL_arrow" disabled="true">텍스트버튼타입4-disable</sui-button>
        <div class="mrB10"></div>
        <sui-button type="button" class="btn_txt_BL_line_arrow">텍스트버튼타입5-블루화살표</sui-button>
        <sui-button type="button" class="btn_txt_BL_line_arrow" disabled="true">텍스트버튼타입5-disable</sui-button>
      </div>
      <!-- <pre>  
        <code>
          &lt;div class="btn_wrap"&gt;
            &lt;button type="button" class="btn_txt_BK"&gt;텍스트버튼타입1&lt;/button&gt;
            &lt;button type="button" class="btn_txt_BK" disabled="true"&gt;텍스트버튼타입1-disable&lt;/button&gt;
            &lt;div class="mrB10"&gt;&lt;/div&gt;
            &lt;button type="button" class="btn_txt_BL"&gt;텍스트버튼타입2-블루&lt;/button&gt;
            &lt;button type="button" class="btn_txt_BL" disabled="true"&gt;텍스트버튼타입2-disable&lt;/button&gt;
            &lt;div class="mrB10"&gt;&lt;/div&gt;
            &lt;button type="button" class="btn_txt_BL_line"&gt;텍스트버튼타입3-블루라인&lt;/button&gt;
            &lt;button type="button" class="btn_txt_BL_line" disabled="true"&gt;텍스트버튼타입3-disable&lt;/button&gt;
            &lt;div class="mrB10"&gt;&lt;/div&gt;
            &lt;button type="button" class="btn_txt_BL_arrow"&gt;텍스트버튼타입4-블루화살표&lt;/button&gt;
            &lt;button type="button" class="btn_txt_BL_arrow" disabled="true"&gt;텍스트버튼타입4-disable&lt;/button&gt;
            &lt;div class="mrB10"&gt;&lt;/div&gt;
            &lt;button type="button" class="btn_txt_BL_line_arrow"&gt;텍스트버튼타입5-블루화살표&lt;/button&gt;
            &lt;button type="button" class="btn_txt_BL_line_arrow" disabled="true"&gt;텍스트버튼타입5-disable&lt;/button&gt;
          &lt;/div&gt;
      </code>
     </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>검색영역 버튼</h4>
      </div>
      <div class="comm_scr_wrap">
        <div class="btn_wrap">
          <sui-button type="button" class="comm_btn_Reset">초기화</sui-button>
          <sui-button type="button" class="comm_btn_Scr">검색</sui-button>
          <sui-button type="button" class="comm_btn_Reset" disabled="true">초기화</sui-button>
          <sui-button type="button" class="comm_btn_Scr" disabled="true">검색</sui-button>
        </div>
      </div>
      <!-- <pre>      
        <code>
        &lt;div class="comm_scr_wrap"&gt;
         &lt;div class="btn_wrap"&gt;
           &lt;button type="button" class="comm_btn_Reset "&gt;초기화&lt;/button&gt;
           &lt;button type="button" class="comm_btn_Scr"&gt;검색&lt;/button&gt;
         &lt;/div&gt;
       &lt;/div&gt;
    </code>
   </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>그리드 버튼 : 행추가 행삭제 취소 - 왼쪽 엑셀다운로드 - 오른쪽</h4>
      </div>
      <div class="comm_gridTop_wrap">
        <div class="btn_wrapL">
          <sui-button type="button" class="comm_btn_gridTop">행삭제</sui-button>
          <sui-button type="button" class="comm_btn_gridTop">행추가</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
          <sui-button type="button" class="comm_btn_gridTop" disabled="true">세부정보</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_Brd" disabled="true">저장</sui-button>
          <sui-tooltip-menu :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]">Tooltip Menu</sui-tooltip-menu>
        </div>
        <div class="btn_wrapR">
          <sui-button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</sui-button>
          <sui-button type="button" class="comm_btn_gridTop comm_ico_ppt">파워포인트</sui-button>
          <sui-button type="button" class="comm_btn_gridTop comm_ico_word">워드파일</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_solid">신규등록</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_solid">자재입고 등록</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_solid" disabled="true">자재입고 등록</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_Brd">저장</sui-button>
          <sui-button type="button" class="comm_btn_gridTop" disabled="true">세부정보</sui-button>
          <sui-button type="button" class="comm_btn_gridTop_Brd" disabled="true">저장</sui-button>
          <sui-button type="button" class="comm_btn_gridTop comm_ico_set"></sui-button> 
          <sui-button type="button" class="comm_btn_gridTop comm_ico_set" disabled></sui-button>  
          <sui-tooltip-menu :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]">Tooltip Menu</sui-tooltip-menu>
      
        </div>
      </div>

      <div class="mrB10"></div>
      <!-- <pre>
        <code>
          &lt;div class="comm_gridTop_wrap"&gt;
            &lt;div class="btn_wrapL"&gt;
              &lt;button type="button" class="comm_btn_gridTop"&gt;행삭제&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop"&gt;행추가&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_Brd"&gt;저장&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop" disabled="true"&gt;세부정보&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_Brd" disabled="true"&gt;저장&lt;/button&gt;
              &lt;sui-tooltip-menu :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]"&gt;Tooltip Menu&lt;/sui-tooltip-menu&gt;
            &lt;/div&gt;
            &lt;div class="btn_wrapR"&gt;
              &lt;button type="button" class="comm_btn_gridTop comm_ico_excel"&gt;엑셀 다운로드&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop comm_ico_ppt"&gt;파워포인트&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop comm_ico_word"&gt;워드파일&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_solid"&gt;신규등록&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_solid"&gt;자재입고 등록&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_solid" disabled="true"&gt;자재입고 등록&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_Brd"&gt;저장&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop" disabled="true"&gt;세부정보&lt;/button&gt;
              &lt;button type="button" class="comm_btn_gridTop_Brd" disabled="true"&gt;저장&lt;/button&gt;
              &lt;sui-tooltip-menu :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]"&gt;Tooltip Menu&lt;/sui-tooltip-menu&gt;
            &lt;/div&gt;
          &lt;/div&gt;
    </code>
   </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>섹션? 버튼 : 기본 버튼 ? - 각 섹션별로 이버튼을 하단 오른쪽에 붙이고 페이지 최종하단에는 페이지 버튼을 붙임 </h4>
      </div>
      <div class="comm_btn_wrap">
        <sui-button type="button" class="comm_sbtn_border">저장</sui-button>
        <sui-button type="button" class="comm_sbtn_border_Prime">저장</sui-button>
        <sui-button type="button" class="comm_sbtn_solid">결재상신</sui-button>
        <sui-button type="button" class="comm_sbtn_border" disabled="true">저장</sui-button>
        <sui-button type="button" class="comm_sbtn_border_Prime" disabled="true">저장</sui-button>
        <sui-button type="button" class="comm_sbtn_solid" disabled="true">결재상신</sui-button>
      </div>
      <!-- <pre>       <code>
         &lt;div class="comm_btn_wrap"&gt;
           &lt;button type="button" class="comm_sbtn_border"&gt;저장&lt;/button&gt;
           &lt;button type="button" class="comm_sbtn_border_Prime"&gt;저장&lt;/button&gt;
           &lt;button type="button" class="comm_sbtn_solid"&gt;결재상신&lt;/button&gt;
           &lt;button type="button" class="comm_sbtn_border" disabled="true"&gt;저장&lt;/button&gt;
           &lt;button type="button" class="comm_sbtn_border_Prime" disabled="true"&gt;저장&lt;/button&gt;
           &lt;button type="button" class="comm_sbtn_solid" disabled="true"&gt;결재상신&lt;/button&gt;
         &lt;/div&gt;
    </code>
   </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>페이지 버튼 : 페이지 최하단 오른쪽에 배치 </h4>
      </div>
      <div class="comm_btn_wrap">
        <sui-button type="button" class="comm_btn_border">저장</sui-button>
        <sui-button type="button" class="comm_btn_border_Prime">저장</sui-button>
        <sui-button type="button" class="comm_btn_solid">결재상신</sui-button>
        <sui-button type="button" class="comm_btn_border" disabled="true">저장</sui-button>
        <sui-button type="button" class="comm_btn_border_Prime" disabled="true">저장</sui-button>
        <sui-button type="button" class="comm_btn_solid" disabled="true">결재상신</sui-button>
        <sui-tooltip-menu class="big" :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]">Tooltip Menu</sui-tooltip-menu>
      </div>
      <!-- <pre>
        <code>
          &lt;div class="comm_btn_wrap"&gt;
            &lt;button type="button" class="comm_btn_border"&gt;저장&lt;/button&gt;
            &lt;button type="button" class="comm_btn_border_Prime"&gt;저장&lt;/button&gt;
            &lt;button type="button" class="comm_btn_solid"&gt;결재상신&lt;/button&gt;
            &lt;button type="button" class="comm_btn_border" disabled="true"&gt;저장&lt;/button&gt;
            &lt;button type="button" class="comm_btn_border_Prime" disabled="true"&gt;저장&lt;/button&gt;
            &lt;button type="button" class="comm_btn_solid" disabled="true"&gt;결재상신&lt;/button&gt;
            &lt;sui-tooltip-menu class="big" :menu-list="[ { label: '맨위로 이동', key: '1' }, { label: '위로 이동', key: '2' }, { label: '아래로 이동', key: '3' } ,{ label: '맨 아래로 이동', key: '4' },{ label: '초기화', key: '5' }]"&gt;Tooltip Menu&lt;/sui-tooltip-menu&gt;
          &lt;/div&gt;
        </code>
   </pre> -->
      <div class="mrB50"></div>
      <div class="comm_title_wrap">
        <h4>페이지 버튼 : 양쪽에 버튼 배치 시</h4>
      </div>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button type="button" class="comm_btn_border">목록</sui-button>
          <sui-button type="button" class="comm_btn_border">이전</sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button type="button" class="comm_btn_border">대상재검토 요청대상재검토 요청대상재검토 요청대상재검토 요청대상재검토 요청</sui-button>
          <sui-button type="button" class="comm_btn_border_Prime">저장</sui-button>
          <sui-button type="button" class="comm_btn_solid">결재상신</sui-button>
        </div>
      </div>
      <div class="mrB10"></div>
      <!-- <pre>     <code>
         &lt;div class="comm_btnBot_wrap"&gt;
           &lt;div class="btn_wrapL"&gt;
               &lt;button type="button" class="comm_btn_border"&gt;목록  &lt;/button&gt;
           &lt;/div&gt;
           &lt;div class="btn_wrapR"&gt;
           &lt;button type="button" class="comm_btn_border"&gt;대상재검토 요청&lt;/button&gt;
           &lt;button type="button" class="comm_btn_border_Prime"&gt;저장&lt;/button&gt;
           &lt;button type="button" class="comm_btn_solid"&gt;결재상신&lt;/button&gt;
         &lt;/div&gt;
         &lt;/div&gt;
   </code>
  </pre> -->
    </sui-page-contents>
  </sui-page>
</template>
<script>
  /*global http*/
  export default {
    name: 'TMP_COM_003',
    data() {
      return {
        singleCheckbox: false,
        multiCheckbox: [],
        radioStrValue: 'radio1',
        totalPageCount: 8,
        totalDataCount: 80,
        currentPage: 1,
        start_date: '',
        end_date: '',
      };
    },
    watch: {
      totalPageCount(newValue) {
        this.totalDataCount = newValue * 10
      }
    },
    computed: {
      disabledStartDate() {
        return {
          from: new Date(this.end_date),
          to: null
        }
      },
      disabledEndDate() {
        return {
          from: null,
          to: new Date(this.start_date)
        }
      }
    },
    mounted() {},
  };
</script>
<style scoped>
  pre {
    border:1px solid #888;
    background-color: #efefef;overflow: auto;
  }
  code {
    font-family: AppleSDGothicNeo-Regular, dotum, "돋움", sans-serif;
    font-size: 14px;
    color:blue;
    line-height: 150%;
  }
</style>
